/**
 * @description : Replace all non alpha-numeric chars by - and apply
 * lowerCase().
 * @param {String} statusCategoryToFormat A statusCategory to format.
 * @returns {String} The formatted dynamic string.
 */
function statusCategoryFilter(configService) {

  return (statusCategoryToFormat) => {

    const statusCatIconsObj = configService.api.status_cat_value_mapping;
    const classNamePart = configService.api.status_cat_class_part;
    const catArray = [];
    let iconIndex = 0;

    angular.forEach(statusCatIconsObj, (value, key) => {

      catArray.push(statusCatIconsObj[key]);

    });

    // We are handling the Error Items Category on the recently-tracked.view.html, not coming from the API.
    iconIndex = catArray.indexOf(statusCategoryToFormat);

    return (iconIndex !== -1) ? `${classNamePart}${iconIndex}` : `${classNamePart}${statusCatIconsObj.no_status}`;

  };

}

export default statusCategoryFilter;



// WEBPACK FOOTER //
// ./src/utils/statusCategory.filter.js